module.exports = __webpack_public_path__ + "static/media/35.94fbf737.gif";